import { Progress } from '@components/atoms/Progress'
import cn from '@components/utils/cn'
import { scopedTranslation } from '@utils/I18n'

import { coverageBarColour, coverageText } from '@utils/embeds/coverage'

const t = scopedTranslation('embeds.events.coverage')

export function CoverageBar({ filled, total }: { filled: number; total: number }) {
  const full = filled >= total
  const share = Math.round((filled / total) * 100)

  return (
    <div className="tw:flex tw:flex-col tw:gap-1">
      <div className="tw:flex tw:flex-wrap tw:items-baseline tw:justify-between tw:gap-x-2">
        <span
          className={cn(
            'tw:whitespace-nowrap tw:text-xs tw:font-semibold',
            full ? 'tw:text-gray-500' : 'tw:text-gray-800'
          )}
        >
          {coverageText(filled, total)}
        </span>
        <span className="tw:whitespace-nowrap tw:text-xs tw:text-gray-500">{t('spots_filled', { filled, total })}</span>
      </div>
      <Progress
        aria-label={t('bar_label')}
        getValueLabel={() => t('bar_value', { filled, total })}
        value={full ? 100 : Math.max(share, 4)}
        progressColor={coverageBarColour(filled, total)}
        className="tw:h-1.5 tw:bg-gray-200"
      />
    </div>
  )
}
